import React, { useEffect, useState } from "react";
import Moment from "moment";
import _ from "lodash";
import {Link} from "react-router-dom";
import { Pagination } from "react-bootstrap";

const LocationMachineHistory = (props: {
  locationMachineHistory: any;
  page: any;
  perPage: any;
  setPage: (page: any) => void;
}) => {
  const {locationMachineHistory, page, setPage} = props;
   const [totalPages, setTotalPages] = useState(0);
    const [locationMachineHistoryData, setLocationMachineHistoryData] = useState<any>([]);

 useEffect(() => {
    setLocationMachineHistoryData(locationMachineHistory?.data)
    setTotalPages(locationMachineHistory?.totalPages ?? 0);
  }, [locationMachineHistoryData, locationMachineHistory]);

  const handlePageChange = (newPage: number) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <div>
      <div className="row">
        <h3 className="fw-bolder my-2 ms-xl-9 ms-3 mt-9 card-title align-items-start flex-column">
          <span className="card-label fw-bolder fs-3">Machine History</span>
          <div className="text-muted fw-semibold fs-7 mt-2">
            Total machines :{" "}
            {locationMachineHistoryData?.length ? locationMachineHistoryData?.length : 0}
          </div>
        </h3>
        <div className="col-12">
          <div className="card mt-9 mx-xl-4">
            <div className="card-body w-100 p-5">
              <div className="table-responsive p-0 pb-2 fs-6 border-0 p-5">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                  <thead>
                    <tr className="fs-5 fw-bold">
                      <th className="fs-5 text-muted">Machine ID</th>
                      <th className="fs-5 text-muted">Serial Number</th>
                      <th className="fs-5 text-muted">Deployment Date</th>
                      <th className="fs-5 text-muted">Machine Status</th>
                      <th className="fs-5 text-muted">Deploying Person</th>
                      <th className="fs-5 text-muted">Deployment Type</th>
                      <th className="fs-5 text-muted">RetiredAt</th>
                      <th className="fs-5 text-muted">CreatedAt</th>
                      <th className="fs-5 text-muted">Location Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {locationMachineHistoryData?.length > 0 ? (
                      Array.from(locationMachineHistoryData).map(
                        (machine: any, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <td>
                                  <Link
                                    data-bs-toggle="tooltip"
                                    title="Click here to view machine"
                                    to={`/machines/list/history/${machine?.machine.id}`}
                                  >
                                    {machine?.machine.uuid ?? ""}
                                  </Link>
                                </td>
                                <td>{machine?.machine?.serialNumber ?? ""}</td>
                                <td>
                                  {Moment.unix(
                                    machine?.machine?.deploymentDate / 1000
                                  )
                                    .local()
                                    .format("YYYY-MM-DD")}
                                </td>
                                <td>
                                  {_.capitalize(
                                    _.lowerCase(
                                      machine?.machine?.machineStatus?.name ??
                                        ""
                                    )
                                  )}
                                </td>
                                <td>
                                  {machine.machine.deployingPerson?.firstName ??
                                    ""}
                                </td>
                                <td>
                                  {machine.machine.deploymentType?.name ?? ""}
                                </td>
                                <td>
                                {machine?.machine?.retiredAt
                                  ? Moment(machine.machine.retiredAt).format("YYYY-MM-DD HH:mm")
                                  : ""}
                                </td>

                                <td>
                                  {Moment.utc(machine.createdAt)
                                    .local()
                                    .format("YYYY-MM-DD HH:mm")}
                                </td>
                                <td>
                                  {machine.machine.location?.locationType
                                    ?.name ?? ""}
                                </td>
                              </tr>
                            </>
                          );
                        }
                      )
                    ) : (
                      <>
                        <tr>
                          <td
                            align="center"
                            className="text-center align-align-items-center justify-content-center"
                            colSpan={11}
                          >
                            No records found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {locationMachineHistory.total > 0 && (
              <div className="card-footer d-flex justify-content-end">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={page === 1}
                  >
                    First
                  </Pagination.First>
                  <Pagination.Prev
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    Previous
                  </Pagination.Prev>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === page}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    Next
                  </Pagination.Next>
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={page === totalPages}
                  >
                    Last
                  </Pagination.Last>
                </Pagination>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationMachineHistory;
